const hu = {
    actionAlready: "Még nem regisztrált? Jelentkezzen be",
    actionExit: "Kijelentkezés",
    actionLogin: "BEJELENTKEZÉS",
    actionRegister: "REGISZTRÁCIÓ",
    actionSave: "MENTÉS",
    actionStart: "KEZDÉS",
    actionContinue: "FOLYTATÁS",
    actionReset: "ÉRTÉKELÉS ÚJRAINDÍTÁSA",
    actionDoDiagnost: "DIAGNOSZTIKA MEGJELENÍTÉSE",
    actionYes: "Igen",
    actionNo: "Nem",
    actionNext: "TOVÁBB",
    actionBusinessCase: "VÁLLALAT JÓ GYAKORLATÁNAK MEGTEKINTÉSE",
    actionBusinessCases: "VÁLLALATOK JÓ GYAKORLATAINAK MEGTEKINTÉSE",
    actionOpenUrl: "URL MEGNYITÁSA",
    actionFilter: "SZŰRŐ",

    /** HOME */
    msgHomeTitleOne: "Mérje fel és növelje bútorgyártó vállalatának körforgásos érettségi szintjét",
    msgHomeSubTitle: "A FurnCIRCLE Online Eszköz értékeli vállalata körforgásos érettségi szintjét a megvalósított körforgásos tervezési stratégiák alapján",

    msgHomeSection2: "A körforgásosság követelményei bővülnek.</br>Ön készen áll?",
    msgHomeSection2Text: "<ul style='padding-left: 20px'><li>Válaszoljon a vállalatánál jelenleg alkalmazott körforgásos tervezési stratégiákkal kapcsolatos kérdésekre.</li><li>Készítse el vállalata körforgásos érettségi indexét.</li><li>Azonosítsa azokat a tervezési stratégiákat és vállalati jó gyakorlatokat, amelyekkel vállalata szintet léphet.</li><li>Tanuljon megvalósult vállalati jó gyakorlatokból, hogy tovább fejleszthesse vállalata körforgásos érettségét.</li></ul>",
    msgHomeSection3: "Partnerek",
    msgHomeSection2Btn: "Kezdje el az értékelést",
    msgHomeSection3Btn: "KAPCSOLAT",

    /** HEADER */
    msgHeader1: "Körforgásos tervezési stratégiák és jó gyakorlatok",
    msgHeader4: "Bejelentkezés",

    /** DRAWER */
    msgCompany: "VÁLLALAT",
    msgDrawer1: "1. Válaszolás",
    msgDrawer2: "2. Értékelés",
    msgDrawer3: "3. Fejlesztés",
    msgDrawer4: "Stratégiai gyűjtemény",
    msgDrawer6: "Beállítások",
    msgDrawer7: "Kijelentkezés",

    /** LOGIN */
    msgWelcome: "Üdvözöljük",
    msgWelcomeSubtitle: "Kérjük, jelentkezzen be a folytatáshoz",

    /** REGISTER */
    msgGetStarted: "Kezdés",
    msgGetStartedSubtitle: "Ez az önértékelési eszköz ingyenes és bizalmas",

    msgFirstname: "Keresztnév",
    msgLastname: "Vezetéknév",
    msgEmail: "E-mail",
    msgPassword: "Jelszó",
    msgConfirmPassword: "Jelszó megerősítése",
    msgCompanyUser: "Vállalat vagy felhasználónév",

    msgNotRegister: "Még nem regisztrált? <b>Hozzon létre egy fiókot itt</b>",
    msgAlreadyRegister: "Már regisztrált? <b>Jelentkezzen be itt</b>",

    /** HOME TOOL */
    msgClickImage: "Kattintson a lineáris és körforgásos modell rendszerének kibővítéséhez.",

    msgArea: "TERÜLET",
    msgProgress: "MEGVÁLASZOLT KÉRDÉSEK",

    msgAssessmentAreas: "Körforgásos tervezési stratégiák és termék-életciklus",
    msgAssessmentDesc: "A körforgásos tervezési stratégiákat a termékek tervezési és fejlesztési szakaszában alkalmazzák, bár pozitív hatásuk a termék-életciklus egy vagy több későbbi szakaszában is megjelenhet. Ezért az egyik módja a körforgásos tervezési stratégiák osztályozásának az, hogy azokat az életciklus érintett szakasza szerint soroljuk be: tervezés, anyagi erőforrások, gyártás, forgalmazás, használat és életciklus vége.<br/><br/><span style=\"font-weight:bold; font-size:16px;\">Kérjük, válaszoljon minden kérdésre az életciklus minden blokkja vagy fázisa esetében, határozza meg vállalata körforgásos érettségi szintjét, és tervezze meg a fejlesztést és az átmenetet egy körforgásosabb gazdaság felé!</span>",

    msgAssessment: "FurnCIRCLE Értékelés",
    msgNotApply: "Jelöld meg az összes választ, amely vonatkozik a vállalatod jelenlegi körforgásos teljesítményére. A válaszok automatikusan elmentésre kerülnek.",
    msgMarkImportant: "Jelölje meg fontosként",
    msgComment: "Megjegyzés",
    msgCommentHolder: "Ide írhat bármilyen kapcsolódó információt vagy saját megjegyzést.",

    /** ANSWER */
    msgPerformance: "Értékelési jelentés",
    msgPerformanceSubtitle: "Tekintse meg vállalata körforgásos érettségi indexét és termékei életciklusának minden fázisát.",
    msgCompanyLevel: "Vállalat körforgásos érettségi indexe (0%-100%)",
    msgBlockArea: "ÉLETCIKLUS FÁZIS",
    msgBlockValues: "ÉRTÉKEK",

    /** ASSESS */
    msgImprovement: "Fejlesztési jelentés",
    msgImprovementMainSubtitle: "Tudja meg, mit tehet vállalata körforgásosságának folyamatos javítása érdekében. Ismerje meg a tervezési stratégiákat és a vállalatok bevált gyakorlatait, hogy vállalatát a következő szintre emelje.</br></br>Azok az életciklus fázisok és körforgásos tervezési stratégiák, amelyek „piros” címkével/körrel rendelkeznek, a maximális értékük 25%-át vagy annál kevesebbet teljesítik, ezért elsődleges prioritásként kezelendők a vállalat körforgásosságának javítása érdekében. Azok a fázisok vagy stratégiák, amelyek „narancssárga” címkével/körrel rendelkeznek, 25% és 75% közötti teljesítményszinttel bírnak, így szintén fontos ezek fejlesztésével foglalkozni. Azok a fázisok vagy stratégiák, amelyek „zöld” címkével/körrel rendelkeznek, 75% feletti teljesítményszinttel bírnak, így kevésbé sürgető a fejlesztésük.",
    msgImprovementSubtitle: "Tudja meg, mit tehet vállalata körforgásosságának folyamatos javítása érdekében. Ismerje meg a tervezési stratégiákat és a vállalatok bevált gyakorlatait, hogy vállalatát a következő szintre emelje.",
    msgLifecyclePhases: "Életciklus fázisok",
    msgLifecycleIndex: "Fázis körforgásossági indexe",
    msgActionsToImplement: "Végrehajtandó intézkedések:",
    msgBaselineScore: "Kezdeti pontszámom",
    msgBusinessCaseEmpty: "Gratulálunk! Ön már megvalósította az ebbe a kategóriába tartozó főbb stratégiákat",

    msgCat1: "GAZDASÁGI ÉS SZERVEZETI",
    msgCat2: "TÁRSADALMI",
    msgCat3: "KÖRNYEZETI",

    /** STRATEGIES COLLECTION */
    msgStrategiesSubtitle: "Böngésszen és fedezze fel a FurnCIRCLE projekt teljes körforgásos tervezési stratégia- és bevált gyakorlati gyűjteményét.",
    msgLifecyclePhase: "Életciklus fázis",
    msgDifficulty: "Végrehajtás nehézsége",
    msgBusinessDynamics: "Értékteremtés vagy értéknyújtás",
    msgBusinessFactors: "Értékajánlat / Költségek / Előnyök",

    /** SETTINGS */
    msgUserInfo: "Felhasználói információk",
    msgUserCredentials: "Felhasználói hitelesítő adatok",

    /** MODAL */
    msgAreSure: "Biztos benne?",

    msgSuccess: "Az adatok sikeresen frissítve",
    msgDeleteSuccess: "Az adatok sikeresen törölve",

    /** ALT TEXT */
    msgSaveCommentAlt: "Mentés a “Megjegyzés” számára. A kérdésekre adott válaszokat nem szükséges elmenteni; azok automatikusan mentésre kerülnek.",
    msgDifficultyAlt: "Ez a címke a körforgásos tervezési stratégia megvalósításának nehézségét jelzi.",
    msgBusinessBlockAlt: "Ez a címke azt jelzi, hogy a CANVAS modell melyik üzleti blokkja (Értékteremtés vagy Értékszállítás) érintett a körforgásos tervezési stratégia megvalósításában.",
    msgImpactBlockAlt: "Ez a címke azt jelzi, hogy a CANVAS modell melyik hatásblokkja (Költségek, Előnyök vagy Értékajánlat) érintett a körforgásos tervezési stratégia megvalósításában.",

    /** ERROR */
    errorOblData: "Töltse ki az összes kötelező mezőt",
    errorEmailFormat: "Hibás e-mail formátum",
    errorUserIncorrect: "Hibás e-mail/jelszó",
    errorSend: "Kommunikációs hiba, kérjük, várjon és próbálja újra később",
    errorLength: "A karakterek maximális száma túllépve",
    errorPassSame: "A jelszavak nem egyeznek meg",

    /** RECOVERY PASS */
    msgRecoveryPassword: "Jelszó helyreállítása",
    msgRecoveryPasswordSubtitle: "Kérjük, adja meg e-mail címét, hogy jelszó-visszaállító kódot kapjon.",
    msgCode: "Kód",
    msgNewPassword: "Új jelszó",
    actionRequestCode: "KÓD IGÉNYLÉSE",
    actionUpdate: "FRISSÍTÉS",
    actionBack: "VISSZA",
    msgForgetPassword: "Elfelejtette a jelszavát?",
    errorRecovery: "Hiba a jelszó helyreállítása során, kérjük, ellenőrizze a megadott kódot",

    /** FOOTER */
    msgFooterContact: "KAPCSOLAT",

    msgFooterGr: "Az Európai Unió által finanszírozott projekt. A kifejtett vélemények kizárólag a szerző(k) álláspontját tükrözik, és nem feltétlenül egyeznek az Európai Unió álláspontjával. Sem az Európai Unió, sem a támogatást nyújtó hatóság nem vonható felelősségre ezekért. Pályázati kiírás és támogatási szerződés hivatkozási száma: SOCPL-2022-SOC-DIALOG-01 (Projekt 101102389)",
    msgCopyright: "Copyright&copy;2025 AMBIT. Minden jog fenntartva",

    msgFooterLegal: "Jogi nyilatkozat",
    msgFooterPrivacy: "Adatvédelem",
    msgFooterCookies: "Süti szabályzat",

    /** PROGRESS VALUES */
    msgProgress0: "Körforgásos tervezési stratégiák",

    /** COMPANY SIZES */
    msgCompanySize: "Vállalat mérete",
    msgCompanySize1: "Kevesebb mint 10 alkalmazott",
    msgCompanySize2: "10-30 alkalmazott",
    msgCompanySize3: "30-50 alkalmazott",
    msgCompanySize4: "Több mint 50 alkalmazott",

    /** PRODUCT TYPES */
    msgProductType: "Az Ön által gyártott terméktípusok",
    msgProductType1: "Kárpitozás",
    msgProductType2: "Matracok",
    msgProductType3: "Kárpitos alapok, kanapék, ágyrácsok",
    msgProductType4: "Alvállalkozó (keretek, megmunkálás, lakkozás stb.)",
    msgProductType5: "Szolgáltatások (speciális logisztika stb.)",
    msgProductType6: "Laptermék bútorok (melamin, furnér, lakk stb.)",
    msgProductType7: "Fa bútorok",
    msgProductType8: "Székek",
    msgProductType9: "Irodabútorok",
    msgProductType10: "Közösségi és közcélú bútorok",
    msgProductType11: "Ajtók, ablakok és asztalosipari termékek",
    msgProductType12: "Egyedi berendezések (üzletek, könyvtárak, éttermek, szakmai vállalkozások stb.)",
    msgProductType13: "Világítás",
    msgProductType14: "Burkolatok és padlózat",
    msgProductType15: "Textil",
    msgProductType16: "Dekorációk",

    /* COUNTRIES */
    msgCountry: "Ország",
    msgAfghanistan: "Afganisztán",
    msgAlbania: "Albánia",
    msgAlgeria: "Algéria",
    msgAmericanSamoa: "Amerikai Szamoa",
    msgAndorra: "Andorra",
    msgAngola: "Angola",
    msgAnguilla: "Anguilla",
    msgAntarctica: "Antarktisz",
    msgAntiguaandBarbuda: "Antigua és Barbuda",
    msgArgentina: "Argentína",
    msgArmenia: "Örményország",
    msgAruba: "Aruba",
    msgAustralia: "Ausztrália",
    msgAustria: "Ausztria",
    msgAzerbaijan: "Azerbajdzsán",
    msgBahamas: "Bahamák",
    msgBahrain: "Bahrein",
    msgBangladesh: "Banglades",
    msgBarbados: "Barbados",
    msgBelarus: "Fehéroroszország",
    msgBelgium: "Belgium",
    msgBelize: "Belize",
    msgBenin: "Benin",
    msgBermuda: "Bermuda",
    msgBhutan: "Bhután",
    msgBolivia: "Bolívia",
    msgBosniaHerzegovina: "Bosznia és Hercegovina",
    msgBotswana: "Botswana",
    msgBouvetIsland: "Bouvet-sziget",
    msgBrazil: "Brazília",
    msgBritishIndian: "Brit Indiai-óceáni Terület",
    msgBrunei: "Brunei",
    msgBulgaria: "Bulgária",
    msgBurkinaFaso: "Burkina Faso",
    msgBurundi: "Burundi",
    msgCambodia: "Kambodzsa",
    msgCameroon: "Kamerun",
    msgCanada: "Kanada",
    msgCapeVerde: "Zöld-foki Köztársaság",
    msgCaymanIslands: "Kajmán-szigetek",
    msgCentralAfrican: "Közép-afrikai Köztársaság",
    msgChad: "Csád",
    msgChile: "Chile",
    msgChina: "Kína",
    msgChristmasIsland: "Karácsony-sziget",
    msgCocosIslands: "Kókusz (Keeling)-szigetek",
    msgColombia: "Kolumbia",
    msgComoros: "Comore-szigetek",
    msgCongo: "Kongó",
    msgRepublicCongo: "Kongói Demokratikus Köztársaság",
    msgCookIslands: "Cook-szigetek",
    msgCostaRica: "Costa Rica",
    msgIvoryCoast: "Elefántcsontpart",
    msgCroatia: "Horvátország",
    msgCuba: "Kuba",
    msgCyprus: "Ciprus",
    msgCzechRepublic: "Cseh Köztársaság",
    msgDenmark: "Dánia",
    msgDjibouti: "Dzsibuti",
    msgDominica: "Dominika",
    msgDominicanRepublic: "Dominikai Köztársaság",
    msgEastTimor: "Kelet-Timor",
    msgEcuador: "Ecuador",
    msgEgypt: "Egyiptom",
    msgEngland: "Anglia",
    msgElSalvador: "Salvador",
    msgEquatorialGuinea: "Egyenlítői-Guinea",
    msgEritrea: "Eritrea",
    msgEstonia: "Észtország",
    msgEthiopia: "Etiópia",
    msgFalklandIslands: "Falkland-szigetek",
    msgFaroeIslands: "Feröer-szigetek",
    msgFijiIslands: "Fidzsi-szigetek",
    msgFinland: "Finnország",
    msgFrance: "Franciaország",
    msgFrenchGuiana: "Francia Guyana",
    msgFrenchPolynesia: "Francia Polinézia",
    msgFrenchSouthern: "Francia Déli Területek",
    msgGabon: "Gabon",
    msgGambia: "Gambia",
    msgGeorgia: "Grúzia",
    msgGermany: "Németország",
    msgGhana: "Ghána",
    msgGibraltar: "Gibraltár",
    msgGreece: "Görögország",
    msgGreenland: "Grönland",
    msgGrenada: "Grenada",
    msgGuadeloupe: "Guadeloupe",
    msgGuam: "Guam",
    msgGuatemala: "Guatemala",
    msgGuernsey: "Guernsey",
    msgGuinea: "Guinea",
    msgGuineaBissau: "Bissau-Guinea",
    msgGuyana: "Guyana",
    msgHaiti: "Haiti",
    msgHeardMcDonald: "Heard-sziget és McDonald-szigetek",
    msgHolySee: "Vatikánváros",
    msgHonduras: "Honduras",
    msgHongKong: "Hongkong",
    msgHungary: "Magyarország",
    msgIceland: "Izland",
    msgIndia: "India",
    msgIndonesia: "Indonézia",
    msgIran: "Irán",
    msgIraq: "Irak",
    msgIreland: "Írország",
    msgIsrael: "Izrael",
    msgIsleMan: "Man-sziget",
    msgItaly: "Olaszország",
    msgJamaica: "Jamaica",
    msgJapan: "Japán",
    msgJersey: "Jersey",
    msgJordan: "Jordánia",
    msgKazakhstan: "Kazahsztán",
    msgKenya: "Kenya",
    msgKiribati: "Kiribati",
    msgKuwait: "Kuvait",
    msgKyrgyzstan: "Kirgizisztán",
    msgLaos: "Laosz",
    msgLatvia: "Lettország",
    msgLebanon: "Libanon",
    msgLesotho: "Lesotho",
    msgLiberia: "Libéria",
    msgLibyanJamahiriya: "Líbia",
    msgLiechtenstein: "Liechtenstein",
    msgLithuania: "Litvánia",
    msgLuxembourg: "Luxemburg",
    msgMacao: "Makaó",
    msgNorthMacedonia: "Észak-Macedónia",
    msgMadagascar: "Madagaszkár",
    msgMalawi: "Malawi",
    msgMalaysia: "Malajzia",
    msgMaldives: "Maldív-szigetek",
    msgMali: "Mali",
    msgMalta: "Málta",
    msgMarshallIslands: "Marshall-szigetek",
    msgMartinique: "Martinique",
    msgMauritania: "Mauritánia",
    msgMauritius: "Mauritius",
    msgMayotte: "Mayotte",
    msgMexico: "Mexikó",
    msgMicronesia: "Mikronézia, Szövetségi Államok",
    msgMoldova: "Moldova",
    msgMonaco: "Monaco",
    msgMongolia: "Mongólia",
    msgMontserrat: "Montserrat",
    msgMontenegro: "Montenegró",
    msgMorocco: "Marokkó",
    msgMozambique: "Mozambik",
    msgMyanmar: "Mianmar",
    msgNamibia: "Namíbia",
    msgNauru: "Nauru",
    msgNepal: "Nepál",
    msgNetherlands: "Hollandia",
    msgNetherlandsAntilles: "Holland Antillák",
    msgNewCaledonia: "Új-Kaledónia",
    msgNewZealand: "Új-Zéland",
    msgNicaragua: "Nicaragua",
    msgNiger: "Niger",
    msgNigeria: "Nigéria",
    msgNiue: "Niue",
    msgNorfolkIsland: "Norfolk-sziget",
    msgNorthKorea: "Észak-Korea",
    msgNorthernIreland: "Észak-Írország",
    msgNorthernMariana: "Északi-Mariana-szigetek",
    msgNorway: "Norvégia",
    msgOman: "Omán",
    msgPakistan: "Pakisztán",
    msgPalau: "Palau",
    msgPalestine: "Palesztina",
    msgPanama: "Panama",
    msgPapua: "Pápua Új-Guinea",
    msgParaguay: "Paraguay",
    msgPeru: "Peru",
    msgPhilippines: "Fülöp-szigetek",
    msgPitcairn: "Pitcairn",
    msgPoland: "Lengyelország",
    msgPortugal: "Portugália",
    msgPuertoRico: "Puerto Rico",
    msgQatar: "Katar",
    msgReunion: "Réunion",
    msgRomania: "Románia",
    msgRussianFederation: "Orosz Föderáció",
    msgRwanda: "Ruanda",
    msgSaintHelena: "Szent Ilona",
    msgSaintKitts: "Saint Kitts és Nevis",
    msgSaintLucia: "Saint Lucia",
    msgSaintPierre: "Saint Pierre és Miquelon",
    msgSaintVincent: "Saint Vincent és a Grenadine-szigetek",
    msgSamoa: "Szamoa",
    msgSanMarino: "San Marino",
    msgSaoTome: "São Tomé és Príncipe",
    msgSaudiArabia: "Szaúd-Arábia",
    msgScotland: "Skócia",
    msgSenegal: "Szenegál",
    msgSerbia: "Szerbia",
    msgSeychelles: "Seychelle-szigetek",
    msgSierraLeone: "Sierra Leone",
    msgSingapore: "Szingapúr",
    msgSlovakia: "Szlovákia",
    msgSlovenia: "Szlovénia",
    msgSolomonIslands: "Salamon-szigetek",
    msgSomalia: "Szomália",
    msgSouthAfrica: "Dél-afrikai Köztársaság",
    msgSouthSandwich: "Dél-Georgia és Déli-Sandwich-szigetek",
    msgSouthKorea: "Dél-Korea",
    msgSouthSudan: "Dél-Szudán",
    msgSpain: "Spanyolország",
    msgSriLanka: "Srí Lanka",
    msgSudan: "Szudán",
    msgSuriname: "Suriname",
    msgSvalbardJan: "Svalbard és Jan Mayen",
    msgSwaziland: "Szváziföld",
    msgSweden: "Svédország",
    msgSwitzerland: "Svájc",
    msgSyria: "Szíria",
    msgTajikistan: "Tádzsikisztán",
    msgTanzania: "Tanzánia",
    msgThailand: "Thaiföld",
    msgTimorLeste: "Kelet-Timor",
    msgTogo: "Togo",
    msgTokelau: "Tokelau",
    msgTonga: "Tonga",
    msgTrinidadTobago: "Trinidad és Tobago",
    msgTunisia: "Tunézia",
    msgTurkey: "Törökország",
    msgTurkmenistan: "Türkmenisztán",
    msgTurksCaicos: "Turks- és Caicos-szigetek",
    msgTuvalu: "Tuvalu",
    msgUganda: "Uganda",
    msgUkraine: "Ukrajna",
    msgUnitedArabEmirates: "Egyesült Arab Emírségek",
    msgUnitedKingdom: "Egyesült Királyság",
    msgUnitedStates: "Egyesült Államok",
    msgUnitedStatesMinor: "Amerikai Egyesült Államok Külső Szigetei",
    msgUruguay: "Uruguay",
    msgUzbekistan: "Üzbegisztán",
    msgVanuatu: "Vanuatu",
    msgVenezuela: "Venezuela",
    msgVietnam: "Vietnám",
    msgVirginIslandsBritish: "Brit Virgin-szigetek",
    msgVirginIslandsUS: "Amerikai Virgin-szigetek",
    msgWales: "Wales",
    msgWallisFutuna: "Wallis és Futuna",
    msgWesternSahara: "Nyugat-Szahara",
    msgYemen: "Jemen",
    msgZambia: "Zambia",
    msgZimbabwe: "Zimbabwe",
}

export default hu;